import React from 'react';
import PropTypes from 'prop-types';

const AlertModal = ({ message, onClose }) => {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Shinkiro Alert</h2>
          <p>{message}</p>
          <div className="modal-footer">
            <button onClick={() => onClose()} className="btn copy-raw-btn">Close</button>
          </div>
        </div>
      </div>
    );
};

AlertModal.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AlertModal;
